export default "__VITE_ASSET__4dddcce4__"